import { create } from 'zustand';
import { persist } from 'zustand/middleware';
import { STORAGE_KEYS } from '@/utils';
import type { ThemeMode } from '@/types';

export type ColorThemeKey = 'blue' | 'emerald' | 'purple' | 'amber' | 'crimson' | 'teal' | 'rose' | 'slate';

export interface ColorThemeOption {
  key: ColorThemeKey;
  label: string;
  color: string;
}

export const COLOR_THEMES: ColorThemeOption[] = [
  { key: 'blue', label: 'Royal Blue', color: '#2563eb' },
  { key: 'emerald', label: 'Emerald Green', color: '#059669' },
  { key: 'purple', label: 'Amethyst Purple', color: '#7c3aed' },
  { key: 'amber', label: 'Sunset Amber', color: '#d97706' },
  { key: 'crimson', label: 'Crimson Red', color: '#dc2626' },
  { key: 'teal', label: 'Midnight Teal', color: '#0d9488' },
  { key: 'rose', label: 'Sakura Rose', color: '#db2777' },
  { key: 'slate', label: 'Slate Gray', color: '#475569' },
];

interface SettingsState {
  theme: ThemeMode;
  colorTheme: ColorThemeKey;
  sidebarCollapsed: boolean;
  compactMode: boolean;
  setTheme: (t: ThemeMode) => void;
  toggleTheme: () => void;
  setColorTheme: (t: ColorThemeKey) => void;
  setSidebarCollapsed: (v: boolean) => void;
  setCompactMode: (v: boolean) => void;
}

export const useSettingsStore = create<SettingsState>()(
  persist(
    (set) => ({
      theme: 'light',
      colorTheme: 'blue',
      sidebarCollapsed: false,
      compactMode: false,
      setTheme: (theme) => set({ theme }),
      toggleTheme: () => set((s) => ({ theme: s.theme === 'light' ? 'dark' : 'light' })),
      setColorTheme: (colorTheme) => set({ colorTheme }),
      setSidebarCollapsed: (sidebarCollapsed) => set({ sidebarCollapsed }),
      setCompactMode: (compactMode) => set({ compactMode }),
    }),
    { name: STORAGE_KEYS.SETTINGS },
  ),
);
